module.exports = __webpack_public_path__ + "img/icon_customization_entry.da2592b0.png";